/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { DataLogOption } from './models';
import { SinglePacket } from '@iotize/tap/service/impl/single-packet';
import { AbstractService, ServiceCallType } from '@iotize/tap';

export class DataLogService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * Get the maximum number of packet
   *
   * LWM2M path: /1024//23
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getMaxPacketCount(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getMaxPacketCountCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//23
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getMaxPacketCountCall(): ServiceCallType {
    const callOptions = { ...this.resources.getMaxPacketCount };

    return callOptions;
  }

  /**
   * Get datalog running status
   *
   * LWM2M path: /1031//0
   *
   * @tapVersion(">=1.0")
   * @return
   */
  isRunning(): Promise<TapResponse<boolean>> {
    return this.serviceCallRunner.execute(this.isRunningCall());
  }

  /**
   *
   *
   * LWM2M path: /1031//0
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  isRunningCall(): ServiceCallType {
    const callOptions = { ...this.resources.isRunning };

    return callOptions;
  }

  /**
   * Run data-log acquisition
   *
   * LWM2M path: /1031//0
   *
   * @tapVersion(">=1.0")
   * @return
   */
  run(): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.runCall());
  }

  /**
   *
   *
   * LWM2M path: /1031//0
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  runCall(): ServiceCallType {
    const callOptions = { ...this.resources.run };

    return callOptions;
  }

  /**
   * Stop data-log acquisition
   *
   * LWM2M path: /1031//1
   *
   * @tapVersion(">=1.0")
   * @return
   */
  stop(): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.stopCall());
  }

  /**
   *
   *
   * LWM2M path: /1031//1
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  stopCall(): ServiceCallType {
    const callOptions = { ...this.resources.stop };

    return callOptions;
  }

  /**
   * Get data log options
   *
   * LWM2M path: /1031//2
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getOptions(): Promise<TapResponse<DataLogOption>> {
    return this.serviceCallRunner.execute(this.getOptionsCall());
  }

  /**
   *
   *
   * LWM2M path: /1031//2
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getOptionsCall(): ServiceCallType {
    const callOptions = { ...this.resources.getOptions };

    return callOptions;
  }

  /**
   * Write data log option
   *
   * LWM2M path: /1031//2
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return
   */
  putOptions(
    /*
     *
     */
    value: DataLogOption,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putOptionsCall(value));
  }

  /**
   *
   *
   * LWM2M path: /1031//2
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return call options
   */
  putOptionsCall(
    /*
     *
     */
    value: DataLogOption,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putOptions };

    callOptions.body = value;

    return callOptions;
  }

  /**
   * Write data log crypto key
   *
   * LWM2M path: /1031//3
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return
   */
  putCryptoKey(
    /*
     *
     */
    value: Uint8Array,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putCryptoKeyCall(value));
  }

  /**
   *
   *
   * LWM2M path: /1031//3
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return call options
   */
  putCryptoKeyCall(
    /*
     *
     */
    value: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putCryptoKey };

    callOptions.body = value;

    return callOptions;
  }

  /**
   * Flush data log packets
   *
   * LWM2M path: /1031//4
   *
   * @tapVersion(">=1.0")
   * @return
   */
  flush(): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.flushCall());
  }

  /**
   *
   *
   * LWM2M path: /1031//4
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  flushCall(): ServiceCallType {
    const callOptions = { ...this.resources.flush };

    return callOptions;
  }

  /**
   * Get number of pending data-log packet
   *
   * LWM2M path: /1031//10
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getPacketCount(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getPacketCountCall());
  }

  /**
   *
   *
   * LWM2M path: /1031//10
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getPacketCountCall(): ServiceCallType {
    const callOptions = { ...this.resources.getPacketCount };

    return callOptions;
  }

  /**
   * Dequeue one packet
   *
   * LWM2M path: /1031//11
   *
   * @tapVersion(">=1.0")
   * @return
   */
  dequeueOnePacket(): Promise<TapResponse<SinglePacket>> {
    return this.serviceCallRunner.execute(this.dequeueOnePacketCall());
  }

  /**
   *
   *
   * LWM2M path: /1031//11
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  dequeueOnePacketCall(): ServiceCallType {
    const callOptions = { ...this.resources.dequeueOnePacket };

    return callOptions;
  }
}
